export default {"src":"/_next/static/media/hugging-face.318578d3.svg","height":88,"width":95};